<template>
  <div class="login top-pad">
    <div id="overlay"></div>

    <div
      v-show="!pageLoading && !visitorLogin && !autoLogin && !hideLoginPage"
      class="login-page-wrapper"
      :style="'background-image:Url(' + pageBg + ')'"
    >
      <div class="login-inner page-effect">
        <div class="login-section">
          <div class="l-logo-area">
            <img id="imgLogo" :src="brandlogo" />
          </div>
          <div
            v-if="eventId && eventId != 'cevent' && !visitorLogin && !autoLogin && showLogin"
            id="dvLogin"
          >
            <div class="l-login-text-head">
              <h3
                class="login-head"
                :style="'color:' + bodyTextColor + ' !important;'"
              >
                {{ $t("login.title") }}
              </h3>
              <p
                class="clsStatement"
                :style="'color:' + bodyTextColor + ' !important;'"
              >
                Please enter your Email and Event Access Code
              </p>
            </div>
            <div class="login-form pt-5 clscheckbox">
              <span style="display: flex" class="mb-1 mb-md-0">Email</span>
              <v-text-field
                tabindex="1"
                background-color="white"
                :rules="enableRules ? [rules.required, rules.email] : []"
                v-model="txtUsername"
                solo
                aria-label="Email"
                @keyup.enter="FirebaseLoginWithAuth()"
              ></v-text-field>
              <span class="mt-n2 mb-1 mb-md-0" style="display: flex"
                >Event Access Code</span
              >
              <v-text-field
                tabindex="2"
                solo
                :type="passwordText"
                :rules="enableRules ? [rules.required] : []"
                v-model="txtPassword"
                background-color="white"
                :append-icon="
                  passwordText == 'password'
                    ? 'remove_red_eye'
                    : 'visibility_off'
                "
                label=""
                @click:append="changePasswordType()"
                @keyup.enter="FirebaseLoginWithAuth()"
              ></v-text-field>

              <div>
                <v-btn
                  id="btnLogin"
                  large
                  :style="
                    'background:' +
                    buttonBackgroundColor +
                    ';color:' +
                    buttonRecoverTextColor
                  "
                  style="font-size: 16px; font-weight: 700"
                  :loading="mainLoginButtonLoader"
                  @click="FirebaseLoginWithAuth()"
                  block
                  >{{ loginText }}</v-btn
                >
              </div>
              <div
                class="stay-sign d-flex justify-content-between mt-4 clscheckbox"
              >
                <span :style="'color:' + bodyTextColor + ' !important;'">
                  <input id="chkStaySigned" type="checkbox" :checked="true" />
                  <span class="pl-2">{{ $t("login.stay") }}</span>
                </span>
              </div>
            </div>
          </div>
          <div v-else-if="!visitorLogin && !autoLogin && showLogin" id="dvLogin">
            <div class="l-login-text-head">
              <h3
                class="login-head"
                :style="'color:' + bodyTextColor + ' !important;'"
              >
                {{ $t("login.title") }}
              </h3>
              <p
                class="clsStatement"
                :style="'color:' + bodyTextColor + ' !important;'"
              >
                <span v-show="!(EnableEmailOnlyLogin || EventLogin)">{{
                  $t("login.subtitle")
                }}</span>
                <span v-show="EnableEmailOnlyLogin || EventLogin">{{
                  $t("login.subtitlewithPassword")
                }}</span>
              </p>
            </div>
            <div class="login-form pt-5 clscheckbox">
              <span style="display: flex" class="mb-1 mb-md-0">Email</span>
              <v-text-field
                tabindex="1"
                background-color="white"
                :rules="enableRules ? [rules.required, rules.email] : []"
                v-model="txtUsername"
                solo
                aria-label="Email"
                @keyup.enter="
                  allowreCAPTCHA ? routeToEvents() : FirebaseLoginWithAuth()
                "
              ></v-text-field>
              <span
                v-if="!(EnableEmailOnlyLogin || EventLogin)"
                class="mt-n2 mb-1 mb-md-0"
                style="display: flex"
                >Password</span
              >
              <v-text-field
                tabindex="2"
                solo
                v-if="!(EnableEmailOnlyLogin || EventLogin)"
                :type="passwordText"
                :rules="enableRules ? [rules.required] : []"
                v-model="txtPassword"
                background-color="white"
                :append-icon="
                  passwordText == 'password'
                    ? 'remove_red_eye'
                    : 'visibility_off'
                "
                label=""
                @click:append="changePasswordType()"
                @keyup.enter="
                  allowreCAPTCHA ? routeToEvents() : FirebaseLoginWithAuth()
                "
              ></v-text-field>

              <div class="forgot-password position-relative mt-n2">
                <p
                  class="forgot-pass-b text-right pb-2"
                  style="margin-bottom: 0px !important"
                  v-show="
                    !(EnableEmailOnlyLogin || EventLogin) && showForgetPwdLink
                  "
                >
                  <a
                    id="forgetPassword"
                    href="#"
                    data-tag="forgotPassword"
                    :style="'color:' + bodyTextColor + ' !important;'"
                    @click.prevent="showForgetPwd"
                    >{{ $t("login.trouble") }}</a
                  >
                </p>
              </div>

              <vue-recaptcha
                v-if="allowreCAPTCHA"
                loadRecaptchaScript
                ref="recaptcha"
                tabindex="3"
                style="width: -webkit-fill-available"
                @verify="onCaptchaVerified"
                @error="resetCaptcha()"
                @click="routeToEvents"
                @expired="resetCaptcha()"
                sitekey="6LdAb50aAAAAAA0bV3G1fkWi5Am1FHbgzr73lSgA"
              >
                <v-btn
                  large
                  :style="
                    'background:' +
                    buttonBackgroundColor +
                    ';color:' +
                    buttonRecoverTextColor
                  "
                  style="font-size: 16px; font-weight: 700"
                  :loading="mainLoginButtonLoader"
                  @click="routeToEvents()"
                  block
                  >{{ loginText }}</v-btn
                >
              </vue-recaptcha>

              <div v-if="!allowreCAPTCHA">
                <v-btn
                  large
                  :style="
                    'background:' +
                    buttonBackgroundColor +
                    ';color:' +
                    buttonRecoverTextColor
                  "
                  style="font-size: 16px; font-weight: 700"
                  :loading="mainLoginButtonLoader"
                  @click="FirebaseLoginWithAuth()"
                  block
                  >{{ loginText }}</v-btn
                >
              </div>
              <div
                class="stay-sign d-flex justify-content-between mt-4 clscheckbox"
              >
                <span :style="'color:' + bodyTextColor + ' !important;'">
                  <input id="chkStaySigned" type="checkbox" :checked="true" />
                  <span class="pl-2">{{ $t("login.stay") }}</span>
                </span>
                <p v-if="AllowRegister == true" id="pSignUp">
                  <span :style="'color:' + bodyTextColor + ' !important;'"
                    >{{ $t("login.newtoonair") }}&nbsp;</span
                  >
                  <!-- <a href>Sign Up Free</a> -->
                  <a
                    value="Register Now"
                    v-if="$t('login.newtoonair')"
                    data-tag="signUP"
                    :style="'color:' + loginButtonFillColor + ' !important;'"
                    @click="goForRegister"
                    >{{ $t("login.register") }}</a
                  >
                </p>
              </div>
            </div>

            <div class="login-button-wrapper" />
          </div>
          <div v-show="showForgotPassword" id="dvForgotPassword">
            <h3
              class="login-head"
              :style="'color:' + bodyTextColor + ' !important;'"
            >
              {{ $t("login.troubleHeader") }}
            </h3>
            <p :style="'color:' + bodyTextColor + ' !important;'">
              {{ $t("login.enteremail") }}
            </p>
            <div class="login-form pt-4">
              <span
                class="mb-md-0 mb-1"
                style="display: flex"
                :style="'color:' + bodyTextColor + ' !important;'"
                >Email Address</span
              >
              <v-text-field
                autofocus
                id="txtEmail"
                class="clscheckbox"
                type="email"
                v-model="forgotEmailText"
                background-color="white"
                solo
                :hide-details="!enableRules"
                :rules="enableRules ? [rules.required, rules.email] : []"
                name="Email"
                @keyup.enter="sendmail"
                aria-label="Email"
              ></v-text-field>
              <div
                class="forgot-password position-relative pb-2"
                :class="enableRules ? '' : 'pt-2'"
              >
                <i
                  id="btnLoader"
                  class="fa fa-spinner fa-spin spinner-loader"
                  style="display: none"
                ></i>

                <!-- that.buttonRecoverTextColor = self.loginButtonTextColor; -->
                <!--
                  :style="
                    'background:' +
                    loginButtonFillColor +
                    ';color:' +
                    loginButtonTextColor
                  "-->
                <v-btn
                  large
                  style="
                    font-size: 16px;
                    font-weight: 700;
                    background: #288af2;
                    color: #fff;
                  "
                  :loading="recoverButtonLoading"
                  @click="sendmail"
                  block
                  >Send Instructions</v-btn
                >
                <input
                  style="display: none"
                  id="recoverPassword"
                  type="submit"
                  value="Send Instructions"
                  data-tag="recover-Password"
                  @click="sendmail"
                />
              </div>

              <!-- <input
                type="url"
                style="margin-top: 5px"
                value="Back to sign in"
                class="clsCancel"
                data-tag="cancelForgetpass"
                @click="hideForgetPwd"
              /> -->
              <v-hover class="" v-slot="{ hover }">
                <p class="text-center">
                  <a
                    href="javascript:void(0);"
                    @click="hideForgetPwd"
                    style="text-decoration: none; font-size: 14px"
                    :style="hover ? 'color:#1976d2' : 'color:#1976d2'"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                    >
                      <path
                        id="backtosignin.svg"
                        fill="#1976d2"
                        d="M162,479l-12.618,0,4.333,4.334a0.976,0.976,0,1,1-1.38,1.381l-5.939-5.939c-0.008-.007-0.012-0.017-0.02-0.024-0.026-.022-0.064-0.013-0.089-0.037a1.02,1.02,0,0,1-.055-0.132,0.939,0.939,0,0,1-.215-0.52c0-.017-0.012-0.031-0.012-0.048s0-.01,0-0.015,0-.01,0-0.015,0.006-.022.007-0.034a0.989,0.989,0,0,1,.255-0.617,0.4,0.4,0,0,1,.02-0.048c0.014-.014.035-0.008,0.048-0.02s0.025-.007.034-0.014l5.966-5.966a0.976,0.976,0,0,1,1.38,1.381L149.383,477,162,477v2Z"
                        transform="translate(-146 -471)"
                      />
                    </svg>
                    &nbsp; Back to Login</a
                  >
                </p>
              </v-hover>
            </div>
          </div>
        </div>
      </div>

      <div v-show="showLoginExtraSection" id="dvLoginExtraSection" class="container">
        <div class="row">
          <div
            v-if="
              linkedinlogin || googlelogin || microsoftlogin || facebooklogin
            "
            class="col-md-10 mx-auto"
          >
            <div class="row sign-in-social">
              <div class="col-lg-4 mt-4">
                <button
                  id="btnFacebook"
                  v-if="facebooklogin != false && facebookClientId"
                  v-facebook-login-button="facebookClientId"
                  data-tag="facebookSignin"
                  class="google-login-button facebook-login mr-3"
                >
                  {{ $t("login.facebooksignin") }}
                </button>
              </div>
              <div class="col-lg-4 mt-4">
                <button
                  v-if="linkedinlogin != false"
                  id="btnLinkedin"
                  class="google-login-button linkedin-login mr-3"
                  data-tag="linkdinSignin"
                  @click="openLinkedInLogin()"
                >
                  {{ $t("login.linkedinsignin") }}
                </button>
              </div>
              <div class="col-lg-4 mt-4">
                <button
                  v-if="googlelogin != false && !googleButtonLoader"
                  id="btnGoogle"
                  v-google-signin-button="googleClientId"
                  class="google-login-button mr-3"
                  data-tag="googleSignin"
                >
                  {{ $t("login.googlesignin") }}
                </button>
                <button
                  v-if="googlelogin != false && googleButtonLoader"
                  id="btnGoogle"
                  class="google-login-button mr-3"
                  data-tag="googleSignin"
                >
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                  <!-- {{ $t("login.googlesignin") }} -->
                </button>
              </div>
              <div class="col-lg-4 mt-4">
                <button
                  v-if="microsoftlogin != false"
                  id="btnMicrosoft"
                  class="google-login-button micronsoft-login"
                  data-tag="microsoftSignin"
                >
                  {{ $t("login.microsoftsignin") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-----21.09.20----->
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-md-10 mx-auto mt-4">
            <div class="or">
              <!--<span id="spnInfoText">Best Experienced on Laptop or Desktop with Chrome browser</span>-->
              <span id="spnInfoText" />
            </div>
          </div>
        </div>
      </div>
      <!---------->

      <div class="container">
        <div class="row">
          <div v-if="privacyPolicy" class="col-md-6 mx-auto l-privacy-policy">
            <p
              v-if="privacyPolicy"
              id="divPrivacyPolicy"
              style="color: black"
              class="term-amd-c pt-5 text-center clscheckbox"
              v-html="privacyPolicy"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <input id="hdidToken" type="hidden" />
    <!-- Othe msg  Modal -->
    <div id="Othermsg-modal" class="modal fade all-modal" data-backdrop="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              {{ $t("login.defaulterrormsg") }}
            </div>
            <div id="pop-up-btn" class="pop-up-btn" style="display: none">
              <a
                id="bckLogin"
                style="display: none"
                href="javascript:void(0)"
                @click="redrictToLogin()"
                class="backtologin"
                >Back To Login</a
              >
              <a
                id="bckCancel"
                style="display: none"
                href="javascript:void(0)"
                @click="closeModal()"
                >Cancel</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="overlay-test" class="login-attendee">
      <div class="attendee-img-hld mx-auto" id="userInitials">
        {{ userInitials }}
      </div>
      <div class="attendee-img-hld mx-auto d-none" id="user-profile-img">
        <img :src="userImage" class="imguserthumb" v-on:load="loadImage()" />
      </div>

      <div class="welcome-attendee">
        <span class="welcome">Welcome </span>
        <span class="attendee">{{ userFirstName }}!</span>
      </div>
      <div id="signingLoader" class="signing-loader">
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div
        v-if="reLoginMessageFlg"
        style="display: contents; justify-content: center; align-items: center"
      >
        <span style="color: #1c1c69; font-weight: 500; font-size: 14px"
          >Looks like your session has expired!</span
        >
        <br />
        <span
          style="color: #3248e6; font-size: 13px; font-weight: 500"
          @click="clearState()"
          >Re-login now</span
        >
      </div>
      <div v-else-if="singleEvent" style="margin-top: 40px">
        <!-- <span
          style="
            color: #ffffff;
            font-weight: 400;
            font-size: 20px;
            background: #4caf50 !important;
            padding: 24px 64px;
            border-radius: 124px;
            cursor: pointer;
          "
          @click="clickToContinue()"
          >Let's Go</span
        > -->
        <a
          href="javascript:void(0);"
          class="base-btn banner-btn position-relative mt-4 mt-sm-5 overflow-hidden"
          @click="clickToContinue()"
        >
          <video autoplay loop muted playsinline>
            <source src="../assets/videos/banner-btn-bg.mp4" type="video/mp4" />
          </video>
          <div
            class="inner-banner-btn position-relative d-flex align-items-center gap-3 z-3"
          >
            {{ buttonText }}
            &nbsp;<v-icon color="#ffffff" size="24px"> mdi-arrow-right</v-icon>
            <!-- <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_15860_7217"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_15860_7217)">
                <path
                  d="M7 17.9998V5.99983H9V17.9998H7ZM11 21.9998V1.99983H13V21.9998H11ZM3 13.9998V9.99983H5V13.9998H3ZM15 17.9998V5.99983H17V17.9998H15ZM19 13.9998V9.99983H21V13.9998H19Z"
                  fill="white"
                />
              </g>
            </svg> -->
          </div>
        </a>
      </div>
    </div>
    <v-snackbar v-model="snackbar" top color="success" :timeout="4000"
      >You are signed in
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
    <div
      v-if="pageLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 90001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g></svg
        ><span style="font-size: 10px">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script>
import GoogleSignInButton from "vue-google-signin-button-directive";
import FacebookLoginButton from "vue-facebook-login-button-directive";
// eslint-disable-next-line no-unused-vars
import jQuery from "jquery";
let $ = jQuery;
import db from "@/components/firebaseInit";
import firebase from "firebase";
import "firebase/auth";
import axios from "axios";
import APIs from "@/components/APIInit";
import router from "@/router";
import store from "@/store";
import eventsubscribe from "@/components/EventSubscribe";
import analytics from "@/components/Analytics";
import VueRecaptcha from "vue-recaptcha";
import jwt_decode from "jwt-decode";
import common from "@/common";
import { bus } from "@/main";
import googleOneTap from "google-one-tap";

//import moment from "moment-timezone";

const landingURLOptions = {
  "/lobby": "Lobby",
  "/sessions": "Sessions",
  "/session_cal": "session_cal",
  "/livestage": "LiveStage",
  "/stageview": "StageView",
  "/attendee": "AttendeeList",
  "/exhibitorshall": "ExhibitorsHall",
  "/mymeetings": "MyMeetings",
  "/myprofile": "MyProfile",
};

var self;
var interval;
var funcTime = [];
var routeReferer = null;
export default {
  directives: {
    GoogleSignInButton,
    FacebookLoginButton,
  },
  components: {
    //ForgotPassword
    "vue-recaptcha": VueRecaptcha,
  },
  data: () => ({
    showForgotPassword: false,
    showLogin: true,
    showLoginExtraSection: true,
    googleButtonLoader: false,
    facebookClientId: "877444356274926",
    facebooklogin: false,
    hideLoginPage: false,
    reLoginMessageFlg: false,
    privacyPolicy: "",
    defaultLoginLandingPage: "",
    snackbar: false,
    mainLoginButtonLoader: false,
    allowreCAPTCHA: false,
    loginText: "",
    recoverButtonLoading: false,
    buttonBackgroundColor: "",
    buttonRecoverTextColor: "",
    enableRules: false,
    forgotEmailText: "",
    googleClientId: "",
    clientId: "",
    eventId: null,
    result: "",
    client: "",
    EmailURL: "",
    DynamicColor: "",
    arrEvents: [],
    hostExistcnt: 1,
    pageBg: null,
    brandlogo: null,
    microsoftlogin: false,
    googlelogin: false,
    linkedinlogin: false,
    AllowRegister: false,
    bodyTextColor: "#fff",
    loginButtonFillColor: "#f00",
    loginButtonTextColor: "#fff",
    EnableEmailOnlyLogin: false,
    EventLoginEnabled: false,
    EventLogin: false,
    eventloginCID: "",
    eventloginEID: "",
    rules: {
      required: (value) => !!value || "This field is required.",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Please enter a valid email address.";
      },
    },
    passwordText: "password",
    txtUsername: "",
    txtPassword: "",
    recaptchaToken: null,
    userImage: "",
    userInitials: null,
    userFirstName: "",
    visitorLogin: false,
    autoLogin: false,
    EnableSelfService: false,
    showGoogleOneTapOption: true,
    pageLoading: true,
    isJoinTokenLogin: false,
    joinToken: "",
    joinEventId: "",
    joinEmailId: "",
    redirect_url: "",
    canRedirectOnLoad: true,
    showForgetPwdLink: true,
    buttonText: "Enter The Experience",
    singleEvent: false,
  }),
  computed: {},
  beforeRouteEnter(to, from, next) {
    routeReferer = from.name;
    //alert("routeReferer: "+routeReferer);
    next(true);
  },
  mounted: async function () {
    this.loginText = self.$t("login.title");
    this.enableRules = false;
    self.arrEvents = [];
    $("#topmenu").hide();
    $("#leftmenu").hide();
    this.getDynamicFont();
    //this.setFirebaseAppsettings();
    // if (!self.visitorLogin) {
    //   self.checkSSOTokenExist();
    // }
    if (location.href.indexOf("#recoverpass") > -1) {
      self.canRedirectOnLoad = false;
      self.showForgetPwd();
    }
    if (
      this.$store.state.token &&
      this.$store.state.historyEvent &&
      this.$store.state.staySignedIn
    ) {
      self.showGoogleOneTapOption = false;
      let isVisitorRemembered = self.isVisitor();
      //alert(self.eventId);
      //var eId = self.getEventId();
      //alert(eId);
      if (!isVisitorRemembered && !self.eventId) {
        bus.$emit("toggleLoader", false);
        self.userImage = self.getCDNUrl(this.$store.state.user[0].profilepic);
        self.userInitials = common.getInitials(this.$store.state.user[0].name);
        self.userFirstName = this.$store.state.user[0].fname;
        document.getElementById("overlay-test").style.display = "flex";
        // var data1 = {
        //   userImage: self.userImage,
        //   userInitials: self.userInitials,
        //   userFirstName: self.userFirstName,
        //   showUserWelcomeLoader: true,
        // };
        self.pageLoading = false;
        self.snackbar = true;
        document.getElementById("signingLoader").style.display = "none";
        self.singleEvent = true;
        let clickToJoinText = self.$store.state.ClickToJoinText;
        if (clickToJoinText) {
          self.buttonText = clickToJoinText;
        }

        //bus.$emit("setUserWelcomeLoader", data1);

        // ******************************************* NEED TO CLICK TO CONTINUE *******************************************

        // Moved to clickToContinue

        // var idtoken = await this.refreshTokenBeforeEventCall();
        // var decoded = jwt_decode(idtoken);
        // document.cookie = "token=";
        // document.cookie = "token=" + idtoken + ";";
        // store.commit("setCurrentLoggedInTime", decoded.exp);
        // store.commit("addToken", idtoken);

        // self.snackbar = true;
        // //self.showSnackbar("You are signed in");
        // this.goToEvent([this.$store.state.historyEvent]);
      }
    } else if (
      this.$store.state.token &&
      this.$store.state.staySignedIn &&
      store.state.DefaultLoginLandingPage == "/clientLobby"
    ) {
      self.showGoogleOneTapOption = false;
      self.snackbar = true;
      // if (self.isClientAdmin() == true) {
      //   router.push("/dashboard");
      // } else {
      //   router.push("/mainlobby");
      // }
      // var data = {
      //   showUserWelcomeLoader: false,
      // };

      //bus.$emit("setUserWelcomeLoader", data);
      router.push("/mainlobby");
    } else if (
      this.$store.state.token &&
      this.$store.state.staySignedIn &&
      store.state.eventCount &&
      store.state.eventCount > 1
    ) {
      self.showGoogleOneTapOption = false;
      self.snackbar = true;
      if (self.EnableSelfService && self.hasEventAdminRole()) {
        if (self.$route.fullPath == "/#cevent") {
          router.push("/eventoverview/#cevent");
        } else {
          router.push({ name: "AdminOverview" });
        }
      } else {
        router.push({ name: "EventList" });
      }
    }

    console.log("hello====");
    console.log("url=====", location.host);
    if (self.visitorLogin) {
      setTimeout(() => {
        //alert("validateVisitorLogin");
        self.validateVisitorLogin();
      }, 1000);
    } else {
      var alEmail = self.$store.state.alEmail;
      //alert(alEmail);
      //alert(self.eventId);
      if (!self.eventId) {
        let urlParams = String(window.location.href).split("#");
        self.eventId =
          urlParams && urlParams[1] && urlParams[1] != "cevent"
            ? urlParams[1]
            : null;
        //alert("mounted: " + self.eventId);
        if (self.eventId == "cevent") {
          self.eventId = null;
        }
      }
      if (self.eventId && alEmail) {
        self.EnableEmailOnlyLogin = true;
        self.EventLoginEnabled = true;
        self.autoLogin = true;
        self.txtUsername = alEmail;
        store.commit("setALEmail", "");
        setTimeout(() => {
          //alert("validateEventLogin");
          self.validateEventLogin(alEmail);
        }, 1000);
      } else {
        if (!self.hideLoginPage) {
          bus.$emit("toggleLoader", false);
        }
      }
    }

    // if (self.showGoogleOneTapOption) {
    //   const options = {
    //     client_id: APIs.googleSignInClientId, // required
    //     auto_select: false, // optional
    //     cancel_on_tap_outside: false, // optional
    //     context: "signin", // optional
    //   };

    //   googleOneTap(options, (response) => {
    //     console.log("googleResponse------", response);
    //     self.OnGoogleAuthSuccess(response.credential);
    //   });
    //}
  },
  beforeMount() {
    $("#topmenu").hide();
    $("#leftmenu").hide();
  },
  created() {
    self = this;
    let urlParams = new URLSearchParams(window.location.search);
    self.joinToken = urlParams.get("jt");
    if (urlParams.has("email")) {
      self.joinEmailId = urlParams.get("email");
    }
    if (urlParams.has("event_id")) {
      self.joinEventId = urlParams.get("event_id");
    }
    if (urlParams.has("redirect_url")) {
      self.redirect_url = urlParams.get("redirect_url");
      //alert("redirect_url: "+self.redirect_url)
      if (self.redirect_url.indexOf("myprofile") > -1) {
        if (window.location.href.indexOf("myprofile#mybooth") > -1) {
          self.redirect_url = self.redirect_url + "#mybooth";
        }
      }
    }
    if (urlParams.has("first_name")) {
      self.userFirstName = urlParams.get("first_name");
    }
    if (self.joinToken && self.joinEmailId && self.joinEventId) {
      self.isJoinTokenLogin = true;
    }
    console.log("created---url==1===", location.host);
    bus.$emit("toggleLoader", true);
    if (location.host.includes("campus.edulife.sg")) {
      let CookieAccessToken = this.getCookie("eduStudentToken");
      if (CookieAccessToken) {
        bus.$emit("toggleLoader", false);
        bus.$emit("toggleTextLoader", true);
        self.hideLoginPage = true;
        self.checkSSOTokenExist();
      } else {
        self.hideLoginPage = false;
        bus.$emit("toggleLoader", false);
      }
    }

    self.googleClientId = APIs.googleSignInClientId;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (window.location.href.includes("visitor-login")) {
      //alert(window.location.href);
      self.visitorLogin = true;
      //self.eventId = self.getVisitorEventId();
      self.eventId = self.joinEventId;
      //alert("self.eventId: " + self.eventId);
      if (self.eventId == "cevent") {
        self.eventId = null;
      }
    } else {
      let urlParams = String(window.location.href).split("#");
      self.eventId = urlParams && urlParams[1] ? urlParams[1] : null;
      if (self.eventId == "cevent") {
        self.eventId = null;
      }
      //alert("created: " + self.eventId);
    }
    if (self.EventLoginEnabled) {
      // /eventlogin/C1591205467009/E1591206650065/preview
      this.eventloginCID = this.$route.params.cid;
      this.eventloginEID = this.$route.params.eid;
      if (this.eventloginCID && this.eventloginEID) {
        this.checkEventLogin();
      }
    }

    //store.commit("ClearState", this);
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      // this.result = "uatonair.e2m.live";
      //this.result = "onair.e2m.live";
      // this.result = "8th-wave.e2m.live";
      //this.result = "millenium2020.e2m.live";
      //this.result = "network.travelgyaan.com";
      //this.result = "onair.e2m.live";
      // this.result = "neche2020am.e2m.live";
      //this.result = "ws.e2m.live";
      //this.result = "uatbni.e2m.live";
      // this.result = "uattest.e2m.live";
      //this.result = "onairstage.e2m.live";
      //this.result = "arrowuniversity.e2m.live";
      //this.result = "8th-wave.e2m.live";
      //this.result = "test.e2m.live";
      //this.result = "arrowevents.e2m.live";
      //this.result = "hb.e2m.live";
      //this.result = "hpa.e2m.live";
      //this.result = "beta.e2m.live";
      this.result = HOSTURL ? HOSTURL : "onair.e2m.live";
      this.result = self.LocalhostDomain();
      //this.result = "campus.edulife.sg";
    } else {
      //this.result = "onair.e2m.live";
      this.result = HOSTURL ? HOSTURL : location.host;
      //this.result = location.host;
    }

    // store.commit("ClearState", this);
    this.getBrandingJsonIfCloudfrontNotPresent(this.result);
    this.setClientSpecificFont();
    // this.getBrandingJson(this.result);
  },
  beforeDestroy() {
    clearInterval(interval);
  },
  methods: {
    async clickToContinue() {
      var idtoken = await self.refreshTokenBeforeEventCall();
      var decoded = jwt_decode(idtoken);
      document.cookie = "token=";
      document.cookie = "token=" + idtoken + ";";
      store.commit("setCurrentLoggedInTime", decoded.exp);
      store.commit("addToken", idtoken);

      self.snackbar = false;
      //self.showSnackbar("You are signed in");
      self.goToEvent([this.$store.state.historyEvent]);
    },
    openLinkedInLogin() {
      window.open(
        "https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=" +
          APIs.LinkedInClientId +
          "&scope=r_emailaddress%20r_liteprofile%20w_member_social&state=987654321&redirect_uri=https://uatonair.e2m.live/provider/linkedIn",
        "_self"
      );
    },
    OnFacebookAuthSuccess(idToken) {
      // Receive the idToken and make your magic with the backend

      self.sendAccessTokenForFBUserVerification(idToken.accessToken);
    },
    OnFacebookAuthFail(error) {
      console.log(error);
    },
    async facebookLoginClick() {
      //accountService.login();

      var accessToken = await this.$store.getters.getFbAccessToken;
      if (accessToken) {
        self.sendAccessTokenForFBUserVerification(accessToken);
      }
    },
    sendAccessTokenForFBUserVerification(accessToken) {
      var postData = {
        token: accessToken,
        provider: "Facebook",
      };
      $.ajax({
        url: APIs.GetSocialTokenAPI,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {},
        type: "POST",
        // mode: 'cors',
        credentials: "include",
        crossDomain: true,
        dataType: "json",
        processData: false,
        data: JSON.stringify(postData),
        success: function (data) {
          if (data.status >= 0) {
            self.showGoogleOneTapOption = false;
            firebase
              .auth()
              .signInWithCustomToken(data.customToken)
              .then(function () {
                var checkGoogleTapToSignin = document.getElementById(
                  "credential_picker_container"
                );
                if (checkGoogleTapToSignin) {
                  document.getElementById(
                    "credential_picker_container"
                  ).style.display = "none";
                }
                store.commit("setLoginType", "GoogleLogin");
                self.getEventDetails(data);
              })
              .catch(function () {
                alert("Unable to login");
              });
          } else {
            $("#btnLogin").val("Log In");
            self.showSnackbar(
              self.$t("login.loginfailedvaildemailandpwd"),
              "error",
              "top"
            );
            return false;
          }
        },
        error: function (xhr, status, error) {
          $("#btnLogin").val("Log In");
          document.getElementById("dvOtherMsg").value =
            "Error in authentication process,please try again later. Error:" +
            error;
          $("#Othermsg-modal").modal("show");
        },
      });
      //-----------------------------------------------------------------
    },

    clearState() {
      bus.$emit("clearState");
    },
    validateVisitorLogin: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientID = obj.client[0].id;
      if (ClientID && self.eventId) {
        db.collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(ClientID)
          .collection("Events")
          .doc(self.eventId)
          .get()
          .then((doc) => {
            bus.$emit("toggleLoader", false);
            var flag = true;
            var msg = "";
            if (doc.exists) {
              var data = doc.data();
              if (!data.IsPublished) {
                flag = false;
                msg =
                  "The Event you are trying to access, is not published. Please contact the Event Organizer.";
              } else if (data.EventTypeId != 2 || !data.AllowRegistration) {
                flag = false;
                msg =
                  "The event you are trying to access is a private event, please contact Event Organizer.";
              } else if (!data.EnableEmailOnlyLogin) {
                router.push("/");
                location.reload();
              } else if (!data.AllowPublicAccess) {
                flag = false;
                msg =
                  "Please register to view this event. Redirecting to registration page...";
                //router.push("/reg/" + self.eventId);
              }
            } else {
              flag = false;
              msg =
                "We could not find this event! Please contact the Event Organizer";
            }
            if (flag) {
              //visitor@e2m.live
              self.FirebaseLoginWithAuth();
            } else {
              self.showSnackbar(msg, "error", "top");
              //alert(msg);
              //if (!location.host.toLowerCase().includes("localhost")) {
              setTimeout(() => {
                router.push("/");
                location.reload();
              }, 5000);
              //}
            }
          });
      } else {
        self.showSnackbar("Something went wrong", "error", "top");
        //if (!location.host.toLowerCase().includes("localhost")) {
        setTimeout(() => {
          router.push("/");
          location.reload();
        }, 5000);
        //}
        bus.$emit("toggleLoader", false);
      }
    },
    validateEventLogin: function (email) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientID = obj.client[0].id;
      if (ClientID && self.eventId) {
        db.collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(ClientID)
          .collection("Events")
          .doc(self.eventId)
          .get()
          .then((doc) => {
            bus.$emit("toggleLoader", false);
            var flag = true;
            var msg = "";
            if (doc.exists) {
              var data = doc.data();
              if (!data.IsPublished) {
                flag = false;
                msg =
                  "The Event you are trying to access, is not published. Please contact the Event Organizer.";
              } else if (data.EventTypeId != 2 || !data.AllowRegistration) {
                flag = false;
                msg =
                  "The event you are trying to access is a private event, please contact Event Organizer.";
              } else if (!data.EnableEmailOnlyLogin) {
                router.push("/#" + self.eventId);
                location.reload();
              }
            } else {
              flag = false;
              msg =
                "We could not find this event! Please contact the Event Organizer";
            }
            self.EnableEmailOnlyLogin = data.EnableEmailOnlyLogin;
            if (flag) {
              self.FirebaseLoginWithAuth(
                self.eventId,
                data.EnableEmailOnlyLogin,
                email
              );
            } else {
              self.showSnackbar(msg, "error", "top");
              //alert(msg);
              //if (!location.host.toLowerCase().includes("localhost")) {
              setTimeout(() => {
                router.push("/#" + self.eventId);
                location.reload();
              }, 5000);
              //}
            }
          });
      } else {
        self.showSnackbar("Something went wrong", "error", "top");
        //if (!location.host.toLowerCase().includes("localhost")) {
        setTimeout(() => {
          router.push("/");
          location.reload();
        }, 5000);
        //}
      }
    },
    setClientSpecificFont() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection("OA_UAT/ClientList/Clients")
        .doc(obj.client[0].id)
        .collection("Features")
        .doc("PostLoginOptions")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let assets = doc.data().customClientFont;
            if (assets) {
              store.commit("AddEventFont", {
                FontPath: assets.FontPath,
                FontFamily: assets.FontFamily,
              });
            } else {
              store.commit("AddEventFont", {
                FontPath: "",
                FontFamily: "",
              });
            }
          } else {
            store.commit("AddEventFont", {
              FontPath: "",
              FontFamily: "",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkSSOTokenExist() {
      let that = this;
      let CookieAccessToken = this.getCookie("eduStudentToken");
      if (CookieAccessToken) {
        //alert("CookieAccessToken");
        console.log("token>>>", CookieAccessToken);
        var apiUrl = APIs.FirebaseAuthApi;
        var postData = {
          SSOToken: CookieAccessToken,
        };

        $.ajax({
          url: apiUrl,
          headers: {
            "Content-Type": "application/json",
          },
          beforeSend: function () {},
          type: "POST",
          credentials: "include",
          crossDomain: true,
          dataType: "json",
          processData: false,
          data: JSON.stringify(postData),
          success: function (data) {
            if (data.status >= 0) {
              bus.$emit("toggleLoader", false);
              bus.$emit("toggleTextLoader", false);
              self.userImage = self.getCDNUrl(data.data.ProfilePictureURL);
              self.userInitials = common.getInitials(data.data.Name);
              self.userFirstName = data.data.FirstName;
              that.$store.commit("addIsSSO", true);
              document.getElementById("overlay-test").style.display = "flex";
              // var data1 = {
              //   userImage: self.userImage,
              //   userInitials: self.userInitials,
              //   userFirstName: self.userFirstName,
              //   showUserWelcomeLoader: true,
              // };

              // bus.$emit("setUserWelcomeLoader", data1);
              self.showGoogleOneTapOption = false;
              firebase
                .auth()
                .signInWithCustomToken(data.customToken)
                .then(function (res) {
                  res.user
                    .getIdToken(true)
                    .then((idToken) => {
                      var checkGoogleTapToSignin = document.getElementById(
                        "credential_picker_container"
                      );
                      if (checkGoogleTapToSignin) {
                        document.getElementById(
                          "credential_picker_container"
                        ).style.display = "none";
                      }
                      var decoded = jwt_decode(idToken);
                      document.cookie =
                        "Set-Cookie:name=" +
                        data.userEvents.result[0].client.ClientName +
                        ";" +
                        "domain=e2m.live";
                      document.cookie = "token=";
                      document.cookie = "token=" + idToken + ";";
                      that.$store.commit("addToken", idToken);
                      that.$store.commit("setCurrentLoggedInTime", decoded.exp);
                      that.$store.commit(
                        "setIsAccessCodeLogin",
                        self.eventId ? true : false
                      );
                      document.cookie = "staysigned=";
                      document.cookie = "userrole=";
                      document.cookie = "userid=";
                      if (
                        $("#chkStaySigned") &&
                        $("#chkStaySigned").length > 0 &&
                        $("#chkStaySigned")[0].checked == true
                      ) {
                        document.cookie = "staysigned=true";
                        store.state.staySignedIn = true;
                        store.state.userRole = data.data.UserRoles;
                        store.state.userId = data.data.UserId;
                        document.cookie =
                          "userrole=" +
                          JSON.stringify(data.data.UserRoles) +
                          ";";
                        document.cookie = "userid=" + data.data.UserId + ";";
                      }
                      ////////// After token and cookies set send to event////////////////////
                      store.commit("setLoginType", "Login");
                      self.recaptchaToken = null;
                      // that.$store.commit(
                      //   "setClientEventBranding",
                      //   data.userEvents.result[0].client.isCustomEventBranding
                      // );
                      let eventCount = data.userEvents.result.reduce(
                        (total, user) => {
                          return total + user.events.length;
                        },
                        0
                      );
                      store.commit("addEventCount", eventCount);
                      $("#btnLogin").prop("disabled", true);
                      var userData = data.data;
                      var userRoles = userData.UserRoles;
                      var roles = [];
                      var isClientAdmin = false;
                      var isEventAdmin = false;
                      if (userRoles != undefined) {
                        userRoles.forEach(function (role) {
                          if (role.RoleID == 2) {
                            isClientAdmin = true;
                          } else if (role.RoleID == 3) {
                            isEventAdmin = true;
                          }
                          roles.push(role.RoleID);
                        });
                      }
                      var result = data.userEvents.result;
                      var events = [];
                      var i;
                      var j;

                      for (i = 0; i < result.length; ++i) {
                        for (j = 0; j < result[i].events.length; j++) {
                          if (!isClientAdmin && !isEventAdmin) {
                            if (result[i].events[j].IsPublished == true) {
                              events.push(result[i].events[j]);
                            }
                          } else {
                            events.push(result[i].events[j]);
                          }
                        }
                      }
                      var UserType = "Attendee";
                      if (userData.RegistrationTypes != undefined)
                        for (var reg in userData.RegistrationTypes) {
                          if (
                            userData.RegistrationTypes[reg].RegistrationType ==
                            "Speaker"
                          ) {
                            UserType = "Speaker";
                          }
                        }
                      store.commit("setMappedEvent", events);
                      store.commit("addEventCount", events.length);
                      store.commit("addAttendeeID", userData.UserId);
                      store.commit("addUser", {
                        id: userData.UserId,
                        Email: userData.Email,
                        name: userData.Name,
                        fname: userData.FirstName,
                        lname: userData.LastName,
                        profilepic: userData.ProfilePictureURL,
                        company: userData.Company,
                        title: userData.Designation,
                        phone: userData.Phone,
                        roles: roles,
                        userType: UserType,
                      });

                      // if (self.isClientAdmin() == true) {
                      //   router.push("/dashboard");
                      // } else {
                      //   router.push("/mainlobby");
                      // }
                      // var data = {
                      //   showUserWelcomeLoader: false,
                      // };

                      // bus.$emit("setUserWelcomeLoader", data);
                      router.push("/mainlobby");
                    })
                    .catch((err) => {
                      console.log(err);
                      bus.$emit("toggleLoader", false);
                    });
                })
                .catch(function (e) {
                  console.log(e);
                  bus.$emit("toggleLoader", false);
                });
            } else {
              console.log("coudn't login with the token, data not received");
              bus.$emit("toggleLoader", false);
              bus.$emit("toggleTextLoader", false);
            }
          },
          error: function (xhr, status, error) {
            console.log("error>>>", error);
            bus.$emit("toggleLoader", false);
            bus.$emit("toggleTextLoader", false);
          },
        });
      } else {
        console.log("token not found");
        bus.$emit("toggleTextLoader", false);
      }
    },
    refreshTokenBeforeEventCall() {
      return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(async function (user) {
          if (user) {
            var token = await firebase.auth().currentUser.getIdToken(true);
            resolve(token);
          } else {
            self.reLoginMessageFlg = true;
            // var data = {
            //   reLoginMessageFlg: false,
            // };

            // bus.$emit("setUserWelcomeLoader", data);
            reject("token not found");
          }
        });
      });
    },
    checkEventLogin() {
      if (self.eventloginCID && self.eventloginEID) {
        //need api call to check email login enabled for the event
        self.EventLogin = true;
      }
    },
    loadImage() {
      $("#userInitials").hide();
      $("#user-profile-img").removeClass("d-none");
    },
    async routeToEvents() {
      this.mainLoginButtonLoader = true;
      await this.$refs.recaptcha.execute();
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      self.FirebaseLoginWithAuth();
    },
    resetCaptcha() {
      this.$refs.recaptcha ? this.$refs.recaptcha.reset() : "";
    },
    LoginOnEnterKeyPress() {
      self.FirebaseLoginWithAuth();
    },
    sendmail() {
      let that = this;
      this.recoverButtonLoading = true;

      $("#recoverPassword").val("");
      document.getElementById("btnLoader").style.display = "block";
      let pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.forgotEmailText || !pattern.test(this.forgotEmailText)) {
        this.enableRules = true;
        that.recoverButtonLoading = false;
        $("#recoverPassword").val("Send Instructions");
        document.getElementById("btnLoader").style.display = "none";
        document.getElementById("bckLogin").style.display = "none";
        document.getElementById("bckCancel").style.display = "none";
        document.getElementById("pop-up-btn").style.display = "none";
        that.recoverButtonLoading = false;
      } else {
        this.enableRules = false;
        var hostUrl = "";
        hostUrl = location.host;
        //hostUrl = "https://onairstage.e2m.live";
        var apiUrl = APIs.ForgetPassword;
        var postData = {
          Email: this.forgotEmailText.toLowerCase(),
          CustomDomain: hostUrl,
        };
        $.ajax({
          url: apiUrl,

          headers: {
            "Content-Type": "application/json",
          },
          beforeSend: function () {},
          type: "POST",
          // mode: 'cors',
          credentials: "include",
          crossDomain: true,
          dataType: "json",
          processData: false,
          data: JSON.stringify(postData),

          success: function (data) {
            $("#recoverPassword").val("Send Instructions");
            self.loginText = self.$t("login.title");
            if (data.status >= 0) {
              that.showSnackbar(
                "You will receive an email with instructions on how to reset your password in a few minutes",
                "success",
                "top"
              );

              that.redrictToLogin();
              that.recoverButtonLoading = false;
              document.getElementById("btnLoader").style.display = "none";
              $("#recoverPassword").val("Send Instructions");
            } else if (data.status == -1) {
              document.getElementById("btnLoader").style.display = "none";
              $("#recoverPassword").val("Send Instructions");
              document.getElementById("bckLogin").style.display = "none";
              document.getElementById("bckCancel").style.display = "none";
              document.getElementById("pop-up-btn").style.display = "none";

              document.getElementById("btnLoader").style.display = "none";
              that.showSnackbar("Email not registered.", "error", "top");
              $("#recoverPassword").val("Send Instructions");
              that.recoverButtonLoading = false;
              return false;
            } else {
              $("#recoverPassword").val("Send Instructions");
              document.getElementById("bckLogin").style.display = "none";
              document.getElementById("bckCancel").style.display = "none";
              document.getElementById("pop-up-btn").style.display = "none";

              document.getElementById("btnLoader").style.display = "none";

              that.showSnackbar("password recovery failed.", "error", "top");
              $("#recoverPassword").val("Send Instructions");
              that.recoverButtonLoading = false;
              return false;
            }
          },
          error: function (xhr, status, error) {
            $("#recoverPassword").val("Send Instructions");
            document.getElementById("bckLogin").style.display = "none";
            document.getElementById("bckCancel").style.display = "none";
            document.getElementById("btnLoader").style.display = "none";
            document.getElementById("pop-up-btn").style.display = "none";
            that.showSnackbar(
              "please try again later. Error:" + error,
              "error",
              "top"
            );

            this.recoverButtonLoading = true;
          },
        });
      }
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    FirebaseLoginWithAuth(eventId, enableEmailOnlyLogin, email) {
      //alert("FirebaseLoginWithAuth: " + eventId);
      //alert("FirebaseLoginWithAuth: " + enableEmailOnlyLogin);
      //alert("FirebaseLoginWithAuth: " + email);
      console.log(`Start Execution time:`, new Date());
      this.showSnackbar("hide");
      this.mainLoginButtonLoader = true;

      let that = this;
      this.enableRules = true;

      if (self.isJoinTokenLogin) {
        //
      } else if (!self.visitorLogin && !enableEmailOnlyLogin) {
        if (self.hostExistcnt <= 0) {
          document.getElementById("dvOtherMsg").innerText = self.$t(
            "login.loginusingcorrecturl"
          );
          $("#Othermsg-modal").modal("show");
          return false;
        }
        if (
          this.txtUsername.toLowerCase() === "" ||
          (!(self.EnableEmailOnlyLogin || self.EventLogin) &&
            this.txtPassword === "")
        ) {
          that.loginText = self.$t("login.title");
          self.showSnackbar(
            this.eventId
              ? self
                  .$t("login.entervalidemailandpwd")
                  .replace("password", "event access code")
              : self.$t("login.entervalidemailandpwd"),
            "error",
            "top"
          );
          that.mainLoginButtonLoader = false;
          self.reLoginMessageFlg = true;
          // var data = {
          //   reLoginMessageFlg: true,
          // };

          // bus.$emit("setUserWelcomeLoader", data);
          if (self.allowreCAPTCHA) self.resetCaptcha();
          self.txtPassword = "";
          return false;
        }
      }

      var apiUrl = APIs.FirebaseAuthApi;
      var postData = {
        emailId: self.txtUsername.toLowerCase(),
        password: self.txtPassword,
      };
      if (self.visitorLogin) {
        postData = {
          emailId: "visitor@e2m.live",
          //eventId: self.eventId,
          //clientId: self.clientId,
        };
        bus.$emit("toggleLoader", true);
      } else {
        if (self.EnableEmailOnlyLogin || self.EventLogin) {
          postData = {
            emailId: self.txtUsername.toLowerCase(),
          };
        } else if (self.eventId && !self.isJoinTokenLogin) {
          postData = {
            emailId: self.txtUsername.toLowerCase(),
            accessCode: self.txtPassword,
            eventId: self.eventId,
            clientId: self.clientId,
          };
        }
        if (eventId && enableEmailOnlyLogin && email) {
          postData = {
            emailId: email,
            //eventId: self.eventId,
            //clientId: self.clientId,
          };
        } else if (self.isJoinTokenLogin) {
          postData.JOINToken = self.joinToken;
          postData.emailId = self.joinEmailId;
          postData.eventId = self.joinEventId;
        }
      }
      $.ajax({
        url: apiUrl,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {},
        type: "POST",
        // mode: 'cors',
        credentials: "include",
        crossDomain: true,
        dataType: "json",
        processData: false,
        data: JSON.stringify(postData),
        success: function (data) {
          debugger;
          self.pageLoading = false;
          console.log(`Api Success Execution time:`, new Date());
          if (data.status >= 0) {
            self.userImage = self.getCDNUrl(data.data.ProfilePictureURL);
            self.userInitials = common.getInitials(data.data.Name);
            self.userFirstName = data.data.FirstName;
            bus.$emit("toggleLoader", false);
            document.getElementById("overlay-test").style.display = "flex";

            // var data1 = {
            //   userImage: self.userImage,
            //   userInitials: self.userInitials,
            //   userFirstName: self.userFirstName,
            //   showUserWelcomeLoader: true,
            // };

            // bus.$emit("setUserWelcomeLoader", data1);

            self.showGoogleOneTapOption = false;
            firebase
              .auth()
              .signInWithCustomToken(data.customToken)
              .then(function (res) {
                console.log(`custom token Success Execution time:`, new Date());
                res.user
                  .getIdToken(true)
                  .then((idToken) => {
                    var checkGoogleTapToSignin = document.getElementById(
                      "credential_picker_container"
                    );
                    if (checkGoogleTapToSignin) {
                      document.getElementById(
                        "credential_picker_container"
                      ).style.display = "none";
                    }
                    var decoded = jwt_decode(idToken);
                    console.log(
                      `get token Success Execution time:`,
                      new Date()
                    );
                    if (data.userEvents.result.length > 0) {
                      document.cookie =
                        "Set-Cookie:name=" +
                        data.userEvents.result[0].client.ClientName +
                        ";" +
                        "domain=e2m.live";
                    }
                    document.cookie = "token=";
                    document.cookie = "token=" + idToken + ";";
                    that.$store.commit("addToken", idToken);
                    that.$store.commit("setCurrentLoggedInTime", decoded.exp);

                    if (!self.visitorLogin && !self.autoLogin) {
                      that.$store.commit(
                        "setIsAccessCodeLogin",
                        self.eventId ? true : false
                      );
                    }
                    document.cookie = "staysigned=";
                    document.cookie = "userrole=";
                    document.cookie = "userid=";
                    if (
                      $("#chkStaySigned") &&
                      $("#chkStaySigned").length > 0 &&
                      $("#chkStaySigned")[0].checked == true
                    ) {
                      document.cookie = "staysigned=true";
                      store.state.staySignedIn = true;
                      //store.state.userRole = data.data.UserRoles;

                      //store.state.userRole = data.data.UserRoles.concat([
                      //  { RoleID: 99, RoleName: "Visitor" },
                      //]);
                      //store.state.userRole = [
                      //  { RoleID: 99, RoleName: "Visitor" },
                      //];
                      store.state.userId = data.data.UserId;
                      document.cookie =
                        "userrole=" + JSON.stringify(data.data.UserRoles) + ";";
                      document.cookie = "userid=" + data.data.UserId + ";";
                    }
                    ////////// After token and cookies set send to event////////////////////
                    store.commit("setLoginType", "Login");
                    self.recaptchaToken = null;
                    // that.$store.commit(
                    //   "setClientEventBranding",
                    //   data.userEvents.result[0].client.isCustomEventBranding
                    // );
                    var eventCount = 0;
                    if (data.userEvents.result.length > 0) {
                      eventCount = data.userEvents.result.reduce(
                        (total, user) => {
                          return total + user.events.length;
                        },
                        0
                      );
                    }
                    store.commit("addEventCount", eventCount);
                    $("#btnLogin").prop("disabled", true);
                    var userData = data.data;
                    var userRoles = userData.UserRoles;
                    var roles = [];
                    var isClientAdmin = false;
                    var isEventAdmin = false;
                    var isUserVisitor = false;
                    if (userRoles != undefined) {
                      userRoles.forEach(function (role) {
                        if (role.RoleID == 2) {
                          isClientAdmin = true;
                        } else if (role.RoleID == 3) {
                          isEventAdmin = true;
                        } else if (role.RoleID == 99) {
                          isUserVisitor = true;
                        }
                        roles.push(role.RoleID);
                      });
                    }
                    if (userData.Email == "visitor@e2m.live") {
                      isUserVisitor = true;
                    }
                    if (isUserVisitor) {
                      if (!roles.includes(99)) {
                        roles.push(99);
                        userRoles.push({ RoleID: 99, RoleName: "Visitor" });
                      }
                    }
                    store.state.userRole = userRoles;

                    var result = data.userEvents.result;
                    var events = [];
                    var i;
                    var j;

                    for (i = 0; i < result.length; ++i) {
                      for (j = 0; j < result[i].events.length; j++) {
                        if (!isClientAdmin && !isEventAdmin) {
                          if (result[i].events[j].IsPublished == true) {
                            events.push(result[i].events[j]);
                          }
                        } else {
                          events.push(result[i].events[j]);
                        }
                      }
                    }
                    if (self.visitorLogin || self.autoLogin) {
                      events = events.filter(function (item) {
                        return item.EventId == self.eventId;
                      });
                    }
                    // events = [events[events.length - 1]];
                    // events = [events[42]];
                    eventCount = 1;
                    store.commit("setMappedEvent", events);
                    store.commit("addEventCount", events.length);
                    store.commit("addAttendeeID", userData.UserId);
                    if (data.data.AdminRoles) {
                      store.commit("setAdminRoles", data.data.AdminRoles);
                    }
                    var UserType = "Attendee";
                    if (userData.RegistrationTypes != undefined)
                      for (var reg in userData.RegistrationTypes) {
                        if (
                          userData.RegistrationTypes[reg].RegistrationType ==
                          "Speaker"
                        ) {
                          UserType = "Speaker";
                        }
                      }

                    store.commit("addUser", {
                      id: userData.UserId,
                      Email: userData.Email,
                      name: userData.Name,
                      fname: userData.FirstName,
                      lname: userData.LastName,
                      profilepic: userData.ProfilePictureURL,
                      company: userData.Company,
                      title: userData.Designation,
                      phone: userData.Phone,
                      roles: roles,
                      userType: UserType,
                    });
                    console.log(
                      `before push Success Execution time:`,
                      new Date()
                    );
                    if (eventCount == 0 && self.EnableSelfService) {
                      if (self.$route.fullPath == "/#cevent") {
                        router.push("/eventoverview/#cevent");
                      } else {
                        router.push({ name: "AdminOverview" });
                      }
                    } else {
                      if (
                        store.state.DefaultLoginLandingPage == "/clientLobby"
                      ) {
                        // if (self.isClientAdmin() == true) {
                        //   router.push("/dashboard");
                        // } else {
                        //   router.push("/mainlobby");
                        // }
                        // var data = {
                        //   showUserWelcomeLoader: false,
                        // };

                        // bus.$emit("setUserWelcomeLoader", data);
                        router.push("/mainlobby");
                      } else {
                        if (events.length == 0) {
                          document.getElementById("dvOtherMsg").innerText =
                            self.$t("login.eventnotpublished");
                          $("#Othermsg-modal").modal("show");
                          $("#btnLogin").val(self.$t("login.title"));
                          self.loginText = self.$t("login.title");
                          that.mainLoginButtonLoader = false;

                          if (self.allowreCAPTCHA) self.resetCaptcha();
                        } else {
                          if (
                            events.length == 1 ||
                            self.isJoinTokenLogin ||
                            (self.joinEventId && self.redirect_url)
                          ) {
                            self.getEventDetails(data);
                            if (self.allowreCAPTCHA) self.resetCaptcha();
                          } else if (events.length > 1) {
                            if (self.hasRedirectUrl() && self.eventId) {
                              self.goToRedirectUrl();
                            } else {
                              if (
                                self.EnableSelfService &&
                                self.hasEventAdminRole()
                              ) {
                                if (self.$route.fullPath == "/#cevent") {
                                  router.push("/eventoverview/#cevent");
                                } else {
                                  router.push({ name: "AdminOverview" });
                                }
                              } else {
                                router.push({ name: "EventList" });
                              }
                            }
                            if (self.allowreCAPTCHA) self.resetCaptcha();
                          }
                        }
                      }
                    }

                    //return true;

                    //}
                  })
                  .catch((err) => {
                    console.log("err=====", err);
                    that.mainLoginButtonLoader = false;
                    self.reLoginMessageFlg = true;
                    // var data = {
                    //   reLoginMessageFlg: true,
                    // };

                    // bus.$emit("setUserWelcomeLoader", data);
                    if (self.allowreCAPTCHA) self.resetCaptcha();
                  });
              })
              .catch(function (e) {
                console.log(e);
                that.mainLoginButtonLoader = false;
                self.reLoginMessageFlg = true;
                // var data = {
                //   reLoginMessageFlg: true,
                // };

                // bus.$emit("setUserWelcomeLoader", data);
                self.loginText = self.$t("login.title");
                self.recaptchaToken = null;
                if (self.allowreCAPTCHA) self.resetCaptcha();
              });
          } else {
            $("#btnLogin").val(self.$t("login.title"));

            self.loginText = self.$t("login.title");
            self.showSnackbar(
              self.eventId
                ? self
                    .$t("login.loginfailedvaildemailandpwd")
                    .replace("password", "event access code")
                : self.$t("login.loginfailedvaildemailandpwd"),
              "error",
              "top"
            );
            that.mainLoginButtonLoader = false;
            self.loginText = self.$t("login.title");
            if (self.allowreCAPTCHA) that.resetCaptcha();
            return false;
          }
        },
        error: function (xhr, status, error) {
          if (self.allowreCAPTCHA) self.resetCaptcha();
          that.mainLoginButtonLoader = false;
          self.reLoginMessageFlg = true;
          // var data = {
          //   reLoginMessageFlg: true,
          // };

          // bus.$emit("setUserWelcomeLoader", data);
          self.loginText = self.$t("login.title");
          document.getElementById("dvOtherMsg").value =
            self.$t("login.errorinauth") + error;
          $("#Othermsg-modal").modal("show");
        },
      });
    },

    staysignin: function () {
      alert("staysignin");
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };

      axios
        .get(APIs.UserEvent, {
          headers: headers,
        })
        .then((response) => {
          store.commit("setLoginType", "Login");
          var result = response.data.result;
          if (response.data.userId !== self.getCookie("userid")) {
            return false;
          }
          var userRoles = self.getCookie("userrole");
          var arr = JSON.parse(userRoles);
          var isClientAdmin = false;
          var isEventAdmin = false;
          var roles = [];
          if (arr != undefined) {
            arr.forEach(function (role) {
              if (role.RoleID == 2) {
                isClientAdmin = true;
              } else if (role.RoleID == 3) {
                isEventAdmin = true;
              }
              roles.push(role.RoleID);
            });
          }
          var channelPrefix = "OAUAT";
          this.createLoginCookieForVideo(response.data.userId, channelPrefix);

          var events = [];
          var i;
          var j;
          for (i = 0; i < result.length; ++i) {
            for (j = 0; j < result[i].events.length; j++) {
              if (!isClientAdmin && !isEventAdmin) {
                if (result[i].events[j].IsPublished == true) {
                  events.push(result[i].events[j]);
                  // store.commit("setMappedEvent", result[i].events[j]);
                }
              } else {
                events.push(result[i].events[j]);
                // store.commit("setMappedEvent", result[i].events[j]);
              }
            }
          }
          store.commit("setMappedEvent", events);
          store.commit("addEventCount", events.length);

          if (events.length == 0) {
            document.getElementById("dvOtherMsg").innerText = self.$t(
              "login.eventnotpublished"
            );
            $("#Othermsg-modal").modal("show");
            $("#btnLogin").val(self.$t("login.title"));
            self.loginText = self.$t("login.title");
            self.mainLoginButtonLoader = false;
          } else if (events.length > 1) {
            $("#btnLogin").prop("disabled", true);
            if (self.EnableSelfService && self.hasEventAdminRole()) {
              if (self.$route.fullPath == "/#cevent") {
                router.push("/eventoverview/#cevent");
              } else {
                router.push({ name: "AdminOverview" });
              }
            } else {
              router.push({ name: "EventList" });
            }

            console.log(funcTime);
          } else {
            $("#btnLogin").prop("disabled", true);
            self.goToEvent(events);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getEventDetails(data) {
      var userData = data.data;
      var email = userData.Email;
      var userRoles = userData.UserRoles;
      var isClientAdmin = false;
      var isEventAdmin = false;
      var roles = [];
      if (userRoles != undefined) {
        userRoles.forEach(function (role) {
          if (role.RoleID == 2) {
            isClientAdmin = true;
          } else if (role.RoleID == 3) {
            isEventAdmin = true;
          }
          roles.push(role.RoleID);
        });
      }
      var channelPrefix = "OAUAT";
      this.createLoginCookieForVideo(userData.UserId, channelPrefix);
      store.commit("addUser", {
        id: userData.UserId,
        Email: email,
        name: userData.Name,
        fname: userData.FirstName,
        lname: userData.LastName,
        profilepic: userData.ProfilePictureURL,
        company: userData.Company,
        title: userData.Designation,
        phone: userData.Phone,
        roles: roles,
      });
      var result = data.userEvents.result;
      var events = [];
      var i;
      var j;
      for (i = 0; i < result.length; ++i) {
        for (j = 0; j < result[i].events.length; j++) {
          if (!isClientAdmin && !isEventAdmin) {
            if (result[i].events[j].IsPublished == true) {
              events.push(result[i].events[j]);
              //store.commit("setMappedEvent", result[i].events[j]);
            }
          } else {
            events.push(result[i].events[j]);
            //store.commit("setMappedEvent", result[i].events[j]);
          }
        }
      }
      // events = [events[events.length - 1]];
      // events = [events[42]];
      if (self.visitorLogin || self.autoLogin) {
        events = events.filter(function (item) {
          return item.EventId == self.eventId;
        });
      }
      store.commit("setMappedEvent", events);
      store.commit("addEventCount", events.length);

      if (data.signInType && data.signInType == "Google") {
        self.googleButtonLoader = false;
      }
      if (self.isJoinTokenLogin || (self.joinEventId && self.redirect_url)) {
        events = events.filter(function (item) {
          return item.EventId == self.joinEventId;
        });
      }
      if (events.length == 0) {
        document.getElementById("dvOtherMsg").innerText = self.$t(
          "login.eventnotpublished"
        );
        $("#Othermsg-modal").modal("show");
        $("#btnLogin").val(self.$t("login.title"));
        self.loginText = self.$t("login.title");
      } else if (events.length > 1) {
        $("#btnLogin").prop("disabled", true);
        if (self.EnableSelfService && self.hasEventAdminRole()) {
          if (self.$route.fullPath == "/#cevent") {
            router.push("/eventoverview/#cevent");
          } else {
            router.push({ name: "AdminOverview" });
          }
        } else {
          router.push({ name: "EventList" });
        }
        console.log(funcTime);
      } else {
        $("#btnLogin").prop("disabled", true);
        if (self.$store.state.staySignedIn || self.visitorLogin) {
          self.$store.state.historyEvent = events[0];
        }
        self.snackbar = true;
        document.getElementById("signingLoader").style.display = "none";
        self.singleEvent = true;
        if (events[0].ClickToJoinText) {
          self.buttonText = events[0].ClickToJoinText;
          self.$store.statesetClickToJoinText = events[0].ClickToJoinText;
        }
        // Moved to clickToContinue
        // self.goToEvent(events);
      }
    },
    changePasswordType() {
      if (this.passwordText == "password") {
        this.passwordText = "text";
      } else if (this.passwordText == "text") {
        this.passwordText = "password";
      }
    },
    goToEvent: async function (eventDoc) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var eventData = eventDoc[0];
      this.$store.state.locale =
        eventData.DefaultLanguage === undefined
          ? "English"
          : eventData.DefaultLanguage;
      store.commit("addAttendeeID", obj.user[0].UserId);
      store.commit("addEventID", eventData.EventId);
      store.commit("addEventCollection", eventData.EventCollectionName);
      store.commit("addEventName", eventData.EventFullName);
      store.commit("addEventSdate", eventData.EventStartDate);
      store.commit("addEventEdate", eventData.EventEndDate);
      store.commit("addZone", eventData.TimeZone);
      store.commit("setBrandingJsonUrl", eventData.brandingJsonUrl);
      let clientName = this.$store.state.client[0].name;
      store.commit("addClientID", {
        id: eventData.ClientId,
        name: clientName,
      });
      // this.$store.commit(
      //   "setClientEventBranding",
      //   eventData.isCustomEventBranding
      // );
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName +
            "/Branding/CustomStyle/EventCustomCSS.json"
        );
        if (brandingData.data.customClientFont != undefined) {
          store.commit("AddEventFont", {
            FontPath: brandingData.data.customClientFont.FontPath,
            FontFamily: brandingData.data.customClientFont.FontFamily,
          });
        } else {
          store.commit("AddEventFont", {
            FontPath: "",
            FontFamily: "",
          });
        }
      } catch (e) {
        store.commit("AddEventFont", {
          FontPath: "",
          FontFamily: "",
        });
        console.log("Error in Branding Json Fetch--", e);
      }

      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          this.item = brandingData.data;
          var bannerDymension = "2048x88"; //"640x88"; // "2048x88";
          var EventBgDymension = "2732x2048";
          var logoDymension = "960x192";
          store.commit("addEventBranding", {
            eventBGImage: self.getCDNUrl(
              brandingData.data.eventBGImage[EventBgDymension]
            ),
            eventLogo: self.getCDNUrl(
              brandingData.data.eventLogo[logoDymension]
            ),
            topBar: brandingData.data.webheaderColorsHexCode
              ? brandingData.data.webheaderColorsHexCode["topBar"]
              : brandingData.data.headerColorsHexCode["topBar"],
            headerBar: brandingData.data.webheaderColorsHexCode
              ? brandingData.data.webheaderColorsHexCode["headerBar"]
              : brandingData.data.headerColorsHexCode["headerBar"],
            fontBar: brandingData.data.webheaderColorsHexCode
              ? brandingData.data.webheaderColorsHexCode["fontBar"]
              : brandingData.data.headerColorsHexCode["fontBar"],
            sideNavigationAndIconColor: brandingData.data.webheaderColorsHexCode
              ? brandingData.data.webheaderColorsHexCode[
                  "sideNavigationAndIconColor"
                ]
              : brandingData.data.headerColorsHexCode[
                  "sideNavigationAndIconColor"
                ],
            banner: self.getCDNUrl(brandingData.data.banner[bannerDymension]),
            mobileBanner: self.getCDNUrl(
              brandingData.data.banner["banner750x103"]
            ),
            shareBanner: self.getCDNUrl(
              brandingData.data.banner["1200x628"]
                ? brandingData.data.banner["1200x628"]
                : ""
            ),
            themeName: brandingData.data["appColorHexCodeType"],
          });
          $("#btnLoadMenu").click();
          this.getMeetingSettings();
          this.getAdvExpoStatus();
          this.getDynamicFont();
          let landingURL = "Lobby";
          if (self.redirect_url) {
            landingURL = self.redirect_url;
          } else {
            if (
              eventData.DefaultLandingURL &&
              landingURLOptions[eventData.DefaultLandingURL] &&
              landingURLOptions[eventData.DefaultLandingURL] != ""
            ) {
              landingURL = landingURLOptions[eventData.DefaultLandingURL];
              store.commit("setDefaultLandingPageInsideEvent", landingURL);
            }
            if (this.$store.state.eventDefaultSessionPage) {
              landingURL =
                landingURLOptions[this.$store.state.eventDefaultSessionPage];
            }
          }

          if (landingURL === "ExhibitorsHall") {
            this.onExpoSelection();
            store.commit("setAdvExpo", true);
          }
          analytics.AddUserLogin(
            eventData.EventCollectionName,
            eventData.EventFullName,
            location.pathname,
            "click",
            "action",
            obj.loginType,
            obj.user[0].id,
            obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
            obj.user[0].Email,
            obj.ClientIP
          );
          if (this.$store.state.staySignedIn) {
            this.$store.state.historyLandinURL = landingURL;
          }
          this.postLeaderboardAction("EVAC");

          if (self.redirect_url) {
            bus.$emit("readChatSettings", {});
            setTimeout(() => {
              bus.$emit("setUserWelcomeLoader", {});
            }, 1000);
            router.push(self.redirect_url);
          } else {
            if (self.hasRedirectUrl() && self.eventId) {
              self.goToRedirectUrl();
            } else {
              router.push({
                name: landingURL,
                params: {
                  sid: eventDoc.id,
                  eCol: eventData.EventCollectionName,
                  ename: eventData.EventFullName,
                  estartdt: eventData.EventStartDate,
                  eenddt: eventData.EventEndDate,
                  tzone: eventData.TimeZone,
                },
              });
            }
          }
        }
      } catch (e) {
        self.mainLoginButtonLoader = false;
        console.log("Error in Branding Json Fetch--", e);
      }
    },
    OnGoogleAuthSuccess(idToken) {
      self.googleButtonLoader = true;
      document.getElementById("hdidToken").value = idToken;
      var base64Url = idToken.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      var jsonstr = JSON.parse(jsonPayload);
      var vemail = jsonstr.email;
      console.log(vemail);

      var postData = {
        token: idToken,
        provider: "Google",
      };
      $.ajax({
        url: APIs.GetSocialTokenAPI,

        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {},
        type: "POST",
        // mode: 'cors',
        credentials: "include",
        crossDomain: true,
        dataType: "json",
        processData: false,
        data: JSON.stringify(postData),

        success: function (data) {
          if (data.status >= 0) {
            self.showGoogleOneTapOption = false;
            firebase
              .auth()
              .signInWithCustomToken(data.customToken)
              .then(function (res) {
                res.user
                  .getIdToken(true)
                  .then((idToken) => {
                    var checkGoogleTapToSignin = document.getElementById(
                      "credential_picker_container"
                    );
                    if (checkGoogleTapToSignin) {
                      document.getElementById(
                        "credential_picker_container"
                      ).style.display = "none";
                    }
                    var decoded = jwt_decode(idToken);

                    if (data.userEvents.result.length > 0) {
                      document.cookie =
                        "Set-Cookie:name=" +
                        data.userEvents.result[0].client.ClientName +
                        ";" +
                        "domain=e2m.live";
                    }
                    document.cookie = "token=";
                    document.cookie = "token=" + idToken + ";";
                    self.$store.commit("addToken", idToken);
                    self.$store.commit("setCurrentLoggedInTime", decoded.exp);

                    if (!self.visitorLogin && !self.autoLogin) {
                      self.$store.commit(
                        "setIsAccessCodeLogin",
                        self.eventId ? true : false
                      );
                    }
                    document.cookie = "staysigned=";
                    document.cookie = "userrole=";
                    document.cookie = "userid=";
                    store.commit("setLoginType", "GoogleLogin");
                    data.signInType = "Google";
                    store.state.staySignedIn = true;
                    self.getEventDetails(data);
                  })
                  .catch((err) => {
                    console.log("err=====", err);
                  });
              })
              .catch(function () {
                alert("Unable to login");
              });
          } else {
            self.googleButtonLoader = false;
            $("#btnLogin").val("Log In");
            self.showSnackbar(
              self.$t("login.loginfailedvaildemailandpwd"),
              "error",
              "top"
            );
            return false;
          }
        },
        error: function (xhr, status, error) {
          self.googleButtonLoader = false;
          $("#btnLogin").val("Log In");
          document.getElementById("dvOtherMsg").value =
            "Error in authentication process,please try again later. Error:" +
            error;
          $("#Othermsg-modal").modal("show");
        },
      });
      //-----------------------------------------------------------------
    },
    OnGoogleAuthFail(error) {
      console.log("Auth fail" + error);
    },
    showForgetPwd: function () {
      this.enableRules = false;
      this.forgotEmailText = "";
      this.showForgotPassword = true;
      this.showLogin = false;
      this.showLoginExtraSection = false;
      // document.getElementById("dvForgotPassword").style.display = "block";
      // document.getElementById("dvLogin").style.display = "none";
      // document.getElementById("dvLoginExtraSection").style.display = "none";
    },
    hideForgetPwd: function () {
      this.showForgotPassword = false;
      this.showLogin = true;
      this.showLoginExtraSection = true;
      // document.getElementById("dvForgotPassword").style.display = "none";
      // document.getElementById("dvLogin").style.display = "block";
      // document.getElementById("dvLoginExtraSection").style.display = "block";
    },

    createLoginCookieForVideo: function (UserID, channelPrefix) {
      var cookieExpDate = new Date();
      var minutes = 1440 * 7; //7 days
      cookieExpDate.setTime(cookieExpDate.getTime() + minutes * 60 * 1000);
      var val = channelPrefix + "_" + UserID.toString();
      document.cookie =
        "vuid=" +
        val +
        "; expires=" +
        cookieExpDate +
        "; path=/;domain=.e2m.live;secure=true";
    },
    goForRegister: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientID = obj.client[0].id;
      //--------------------OPENevents--------------------------------------------------------------------------
      var cnt = 0;
      db.collection("OA_UAT")
        .doc("ClientList")
        .collection("Clients")
        .doc(ClientID)
        .collection("Events")
        .where("EventTypeId", "==", 2)
        .where("AllowRegistration", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            cnt++;
            if (doc != undefined) {
              if (doc.data() != undefined) {
                self.arrEvents.push(doc.data().EventId); //doc.data().EventFullName);
                self.arrEvents.push(doc.data().EventFullName);
              }
            }
          });

          //if (cnt > 0) {
          if (self.EnableSelfService) {
            if (cnt == 1) {
              let str = self.arrEvents[1].replace(/ /g, "_");
              let str2 = str.replace(/%20/g, " ");
              router.push({
                path: "/eventv3/" + self.arrEvents[0] + "/" + str2,
              });
            } else {
              router.push({
                path: "/showcase",
              });
            }
          } else {
            if (cnt == 1) {
              let str = self.arrEvents[1].replace(/ /g, "_");
              let str2 = str.replace(/%20/g, " ");
              router.push({
                path: "/eventv3/" + self.arrEvents[0] + "/" + str2,
              });
            } else {
              router.push({
                path: "/events",
              });
            }
          }
          // } else {
          //   document.getElementById("dvOtherMsg").innerText =
          //     "Currently there are no events for you to register, please contact Event Organizer for assistance.";
          //   $("#Othermsg-modal").modal("show");
          // }
        });
    },
    getBrandingJson(hostName) {
      let that = this;
      axios
        .get(
          "https://d37yyfolhq99bh.cloudfront.net/" + hostName + "/branding.json"
        )
        .then((res) => {
          self.clientId = res.data.ClientId;
          if (self.clientId == "C1649103310659") {
            self.showForgetPwdLink = false;
          }
          if (res.data.reCAPTCHA) {
            self.allowreCAPTCHA = res.data.reCAPTCHA;
          }
          if (res.data.EnableEmailOnlyLogin) {
            self.EnableEmailOnlyLogin = res.data.EnableEmailOnlyLogin;
          }
          if (res.data.TermsOfUseText) {
            self.privacyPolicy = res.data.TermsOfUseText;
          }
          if (res.data.Infotext) {
            if (res.data.Infotext.endsWith("</p>")) {
              document.getElementById("spnInfoText").innerHTML =
                res.data.Infotext.substring(
                  0,
                  res.data.Infotext.length - 4
                ).substring(3, res.data.Infotext.length);
            } else {
              document.getElementById("spnInfoText").innerHTML =
                res.data.Infotext;
            }
          }

          if (res.data.Favicon != undefined) {
            if (res.data.Favicon != "") {
              var link =
                document.querySelector("link[rel*='icon']") ||
                document.createElement("link");
              link.type = "image/x-icon";
              link.rel = "shortcut icon";
              link.href = res.data.Favicon; // 'http://www.stackoverflow.com/favicon.ico';
              document.getElementsByTagName("head")[0].appendChild(link);
            }
          }

          self.bodyTextColor = res.data.LoginAssets.bodyTextColor;
          self.loginButtonFillColor = res.data.LoginAssets.loginButtonFillColor;
          self.loginButtonTextColor = res.data.LoginAssets.loginButtonTextColor;

          this.pageBg = res.data.LoginAssets.bg2732x2048;
          this.brandlogo = res.data.LoginAssets.logo;
          this.linkedinlogin = res.data.SocialAuths[0].LinkedIn;
          this.googlelogin = res.data.SocialAuths[0].Google;
          this.microsoftlogin = res.data.SocialAuths[0].Microsoft;
          this.facebooklogin = res.data.SocialAuths[0].Facebook
            ? res.data.SocialAuths[0].Facebook
            : false;
          //this.AllowRegister = res.data.AllowRegister;
          this.hostExistcnt = 1;

          $(document).attr("title", "Login - " + res.data.ClientName);
          store.commit("addClientID", {
            id: res.data.ClientId,
            name: res.data.ClientName,
          });
          store.commit("addAuth", {
            Microsoft: res.data.SocialAuths.Microsoft,
            google: res.data.SocialAuths.Google,
            linkedin: res.data.SocialAuths.LinkedIn,
          });
          store.commit("addBranding", {
            bg: res.data.LoginAssets.bg2732x2048,
            logo: res.data.LoginAssets.logo,
            favicon: res.data.Favicon,
            bg2: res.data.EventListAssets.bg2048x2732,
            banner: res.data.EventListAssets.banner2048x88,
            bodyTextColor: res.data.LoginAssets.bodyTextColor,
            mobileBanner: res.data.EventListAssets.banner750x103,
          });

          $(".login-form input[type='submit']").css(
            "background",
            self.loginButtonFillColor
          );
          that.buttonBackgroundColor = self.loginButtonFillColor;
          that.buttonRecoverTextColor = self.loginButtonTextColor;
          $(".login-form input[type='submit']").css(
            "color",
            self.loginButtonTextColor
          );

          $(".login-head").css("color", res.data.LoginAssets.bodyTextColor);
          $(".clsStatement").css("color", res.data.LoginAssets.bodyTextColor);
          $(".clscheckbox").css("color", res.data.LoginAssets.bodyTextColor);

          $(".clscheckbox p").css("color", res.data.LoginAssets.bodyTextColor);
          $(".login-section p").css(
            "color",
            res.data.LoginAssets.bodyTextColor
          );
          $(".p.term-amd-c.pt-5.text-center").css("color", "black");
          this.DynamicColor = res.data.LoginAssets.bodyTextColor;

          $(":root").css("--body-text-color", this.DynamicColor);
          self.AllowRegister = res.data.AllowRegister;
        })
        .catch((error) => {
          self.getBrandingJsonIfCloudfrontNotPresent(hostName);
          console.log("getBrandingJson: " + error);
        });
    },
    getBrandingJsonIfCloudfrontNotPresent(hostName) {
      var path = APIs.googleSoragePath;
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          if (res.data.CustomDomain) {
            store.commit("setCustomDomain", res.data.CustomDomain);
          }
          if (res.data.reCAPTCHA) {
            self.allowreCAPTCHA = res.data.reCAPTCHA;
          }
          if (res.data.AdditionalMenu)
            store.state.AdditionalMenu = res.data.AdditionalMenu;
          if (
            res.data.PostLoginOptions &&
            res.data.PostLoginOptions.DefaultLoginLandingPage
          ) {
            if (
              res.data.PostLoginOptions.DefaultLoginLandingPage.includes(
                "client"
              )
            ) {
              store.commit("setDefaultLoginLandingPage", "/clientLobby");
            } else {
              store.state.DefaultLoginLandingPage =
                res.data.PostLoginOptions.DefaultLoginLandingPage;
            }
          }
          if (
            res.data.PostLoginOptions &&
            res.data.PostLoginOptions.ClientLobbyHTML
          ) {
            store.state.ClientLobbyHTML =
              res.data.PostLoginOptions.ClientLobbyHTML;
          }
          // if (res.data.EventListAssets) {
          //   let assets = res.data.EventListAssets;
          //   store.commit("addEventBranding", {
          //     eventBGImage: assets.bg2732x2048,
          //     banner: assets.banner2048x88,
          //     topBar: assets.topBar,
          //     mobileBanner: assets.banner750x103,
          //   });
          // }
          self.clientId = res.data.ClientId;
          if (self.clientId == "C1649103310659") {
            self.showForgetPwdLink = false;
          }
          if (res.data.EnableEmailOnlyLogin) {
            self.EnableEmailOnlyLogin = res.data.EnableEmailOnlyLogin;
          }
          if (res.data.TermsOfUseText) {
            self.privacyPolicy = res.data.TermsOfUseText;
          }
          if (res.data.Infotext) {
            if (res.data.Infotext.endsWith("</p>")) {
              document.getElementById("spnInfoText").innerHTML =
                res.data.Infotext.substring(
                  0,
                  res.data.Infotext.length - 4
                ).substring(3, res.data.Infotext.length);
            } else {
              document.getElementById("spnInfoText").innerHTML =
                res.data.Infotext;
            }
          }

          if (res.data.Favicon != undefined) {
            if (res.data.Favicon != "") {
              var link =
                document.querySelector("link[rel*='icon']") ||
                document.createElement("link");
              link.type = "image/x-icon";
              link.rel = "shortcut icon";
              link.href = res.data.Favicon; // 'http://www.stackoverflow.com/favicon.ico';
              document.getElementsByTagName("head")[0].appendChild(link);
            }
          }
          if (
            res.data.PostLoginOptions &&
            res.data.PostLoginOptions.customClientFont
          ) {
            let assets = res.data.PostLoginOptions.customClientFont;
            store.commit("AddEventFont", {
              FontPath: assets.FontPath,
              FontFamily: assets.FontFamily,
            });
          } else {
            store.commit("AddEventFont", {
              FontPath: "",
              FontFamily: "",
            });
          }
          self.bodyTextColor = res.data.LoginAssets.bodyTextColor;
          self.loginButtonFillColor = res.data.LoginAssets.loginButtonFillColor;
          self.loginButtonTextColor = res.data.LoginAssets.loginButtonTextColor;
          self.buttonBackgroundColor =
            res.data.LoginAssets.loginButtonFillColor;
          self.buttonRecoverTextColor =
            res.data.LoginAssets.loginButtonTextColor;
          this.pageBg = self.getCDNUrl(res.data.LoginAssets.bg2732x2048);
          this.brandlogo = self.getCDNUrl(res.data.LoginAssets.logo);
          this.linkedinlogin = res.data.SocialAuths[0].LinkedIn;
          this.googlelogin = res.data.SocialAuths[0].Google;
          this.microsoftlogin = res.data.SocialAuths[0].Microsoft;
          this.facebooklogin = res.data.SocialAuths[0].Facebook
            ? res.data.SocialAuths[0].Facebook
            : false;
          //this.AllowRegister = res.data.AllowRegister;
          this.hostExistcnt = 1;
          //this.showGoogleOneTapOption = this.googlelogin == true ? true : false;

          if (this.googlelogin && this.showGoogleOneTapOption) {
            const options = {
              client_id: APIs.googleSignInClientId, // required
              auto_select: false, // optional
              cancel_on_tap_outside: false, // optional
              context: "signin", // optional
            };

            googleOneTap(options, (response) => {
              console.log("googleResponse------", response);
              self.OnGoogleAuthSuccess(response.credential);
            });
          }

          $(document).attr("title", "Login - " + res.data.ClientName);
          store.commit("addClientID", {
            id: res.data.ClientId,
            name: res.data.ClientName,
          });
          store.commit("addAuth", {
            Microsoft: res.data.SocialAuths.Microsoft,
            google: res.data.SocialAuths.Google,
            linkedin: res.data.SocialAuths.LinkedIn,
          });
          store.commit("addBranding", {
            bg: self.getCDNUrl(res.data.LoginAssets.bg2732x2048),
            logo: self.getCDNUrl(res.data.LoginAssets.logo),
            favicon: self.getCDNUrl(res.data.Favicon),
            bg2: self.getCDNUrl(res.data.EventListAssets.bg2048x2732),
            banner: self.getCDNUrl(res.data.EventListAssets.banner2048x88),
            bodyTextColor: self.getCDNUrl(res.data.LoginAssets.bodyTextColor),
            mobileBanner: self.getCDNUrl(
              res.data.EventListAssets.banner750x103
            ),
          });
          store.commit("setEnableSelfService", res.data.EnableSelfService);
          self.EnableSelfService = res.data.EnableSelfService
            ? res.data.EnableSelfService
            : false;
          //alert(self.EnableSelfService);
          $(".login-form input[type='submit']").css(
            "background",
            self.loginButtonFillColor
          );
          $(".login-form input[type='submit']").css(
            "color",
            self.loginButtonTextColor
          );

          $(".login-head").css("color", res.data.LoginAssets.bodyTextColor);
          $(".clsStatement").css("color", res.data.LoginAssets.bodyTextColor);
          $(".clscheckbox").css("color", res.data.LoginAssets.bodyTextColor);

          $(".clscheckbox p").css("color", res.data.LoginAssets.bodyTextColor);
          $(".login-section p").css(
            "color",
            res.data.LoginAssets.bodyTextColor
          );
          $(".p.term-amd-c.pt-5.text-center").css("color", "black");
          this.DynamicColor = res.data.LoginAssets.bodyTextColor;

          $(":root").css("--body-text-color", this.DynamicColor);
          self.AllowRegister = res.data.AllowRegister;

          if (!routeReferer) {
            store.commit("setPublicEventCollection", "");
          }
          if (self.isJoinTokenLogin) {
            self.FirebaseLoginWithAuth(
              self.joinEventId,
              false,
              self.joinEmailId
            );
          } else {
            if (
              !res.data.DefaultLandingPage ||
              res.data.DefaultLandingPage == "/" ||
              routeReferer
            ) {
              self.pageLoading = false;
            } else {
              if (self.joinEventId && self.redirect_url) {
                //self.pageLoading = false;
              } else {
                if (res.data.DefaultLandingPage == "customlanding") {
                  if (self.clientId == "C1594240425613") {
                    store.commit(
                      "setPublicEventCollection",
                      "OA_UAT_C1594240425613E1647445200290"
                    );
                  } else if (self.clientId == "C1647457916091") {
                    store.commit(
                      "setPublicEventCollection",
                      "OA_UAT_C1647457916091E1647459328886"
                    );
                  }
                  if (self.canRedirectOnLoad) {
                    router.push("/home");
                  } else {
                    self.pageLoading = false;
                  }
                } else {
                  if (self.clientId == "C1647457916091") {
                    store.commit(
                      "setPublicEventCollection",
                      "OA_UAT_C1647457916091E1647459328886"
                    );
                    if (self.canRedirectOnLoad) {
                      router.push("/home");
                    } else {
                      self.pageLoading = false;
                    }
                  } else {
                    if (self.canRedirectOnLoad) {
                      router.push(res.data.DefaultLandingPage);
                    } else {
                      self.pageLoading = false;
                    }
                  }
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log("getBrandingJson: " + error);
          self.pageLoading = false;
        });
    },
    //Moved from Lobby to EventSelection----START
    getDynamicFont: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
    },
    getMeetingSettings: function () {
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(APIs.MeetingAPIConfig.GetConfig, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          var res = response.data;
          var MObj = new Object();
          //console.log(moment.utc(res.data.MeetingStartTimestampUTC).local());
          MObj.Slot = res.data.Slots;
          MObj.StartDate1 = res.data.StartDate;
          MObj.EndDate1 = res.data.EndDate;
          //MObj.StartDate = moment(res.data.MeetingStartTimestampUTC / 1000);
          //MObj.EndDate = new Date(res.data.MeetingEndTimestampUTC / 1000);
          MObj.StartDate = {
            _seconds: res.data.MeetingStartTimestampUTC / 1000,
            _nanoseconds: 0,
          };
          MObj.EndDate = {
            _seconds: res.data.MeetingEndTimestampUTC / 1000,
            _nanoseconds: 0,
          };
          MObj.AvailabilityFromTime = res.data.AvailabilityFromTime;
          MObj.AvailabilityToTime = res.data.AvailabilityToTime;
          MObj.ButtonLabel = res.data.ButtonLabel;
          MObj.Duration = res.data.Duration;
          if (res.data.ByTimezone !== undefined) {
            MObj.ByTimezone = res.data.ByTimezone;
          } else {
            MObj.ByTimezone = false;
          }
          if (res.data.Items && res.data.Items.length > 0) {
            MObj.Items = res.data.Items;
          }
          store.commit("addMeetingSettings", MObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAdvExpoStatus: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          this.SubscribeForWebPush(); //kk
          querySnapshot.forEach((doc) => {
            if (doc.data().EnableEnhancedExpoMode === true) {
              store.commit("setAdvExpo", true);
            } else {
              store.commit("setAdvExpo", false);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onExpoSelection() {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().EnableEnhancedExpoMode === true) {
                  router.push("/exhibitorshall");
                  store.commit("setAdvExpo", true);
                } else {
                  store.commit("setAdvExpo", false);
                  router.push("/exhibitor");
                }
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    SubscribeForWebPush() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      eventsubscribe.SubscribeUser(
        obj.eventcollectionname,
        obj.user[0].Email,
        obj.user[0].id,
        obj.ShowNotification
      );
    },
    redrictToLogin() {
      $("#Othermsg-modal").modal("hide");
      this.showForgotPassword = false;
      this.showLogin = true;
      this.showLoginExtraSection = true;
      // document.getElementById("dvForgotPassword").style.display = "none";
      // document.getElementById("dvLogin").style.display = "block";
      // document.getElementById("dvLoginExtraSection").style.display = "block";
    },
    closeModal() {
      $("#Othermsg-modal").modal("hide");
    },
    //Moved from Lobby to EventSelection----END
    getVisitorEventId: function () {
      var result = "";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.urlReq && !obj.urlReq.includes("undefined")) {
        var pathArray = obj.urlReq.split("/");
        if (pathArray.length > 0) {
          var eid = pathArray[pathArray.length - 1];
          if (eid) {
            eid = eid.toLowerCase();
            if (eid.startsWith("e")) {
              result = eid.toUpperCase();
            }
          }
        }
      }
      return result;
    },
    hasRedirectUrl1: function () {
      var result = false;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.urlReq && !obj.urlReq.includes("undefined")) {
        var pathArray = obj.urlReq.split("/");
        if (pathArray.length > 1) {
          result = true;
        }
      }
      return result;
    },
    goToRedirectUrl1: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.urlReq && !obj.urlReq.includes("undefined")) {
        var url = obj.urlReq;
        store.commit("setUrlReq", "");
        if (url) {
          url = url.replace("/" + self.eventId, "");
          router.push(url);
        }
      }
    },
    hasRedirectUrl: function () {
      var result = false;
      if (self.redirect_url) {
        result = true;
      }
      //alert("hasRedirectUrl:"+result);
      return result;
    },
    goToRedirectUrl: function () {
      if (self.redirect_url) {
        router.push(self.redirect_url);
      }
      //alert("hasRedirectUrl:"+self.redirect_url);
    },
  },
};
</script>

<style>
:root {
  --body-text-color: #5a646e;
}
.or {
  white-space: nowrap;
}
.login-form input::placeholder {
  color: var(--body-text-color) !important;
}

.login-form input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--body-text-color) !important;
}

.login-form input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--body-text-color) !important;
}
.pop-up-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.pop-up-btn a {
  display: inline-block;
  padding: 8px 12px;
  background: #ec0e0e;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 4px;
  margin: 0 5px;
}
.pop-up-btn a.backtologin {
  background: #10881e;
}
.pop-up-btn a:hover {
  color: #fff;
}
.spinner-loader {
  position: absolute;
  color: #fff;
  left: 49%;
  top: 26%;
  transform: translate(-50%, -50%);
  font-size: 20px !important;
}
#overlay-test {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 2;
  cursor: pointer;
}
.login-attendee {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login-attendee .attendee-img-hld {
  width: 132px;
  height: 132px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 54px;
  text-transform: uppercase;
  border: 1px solid #f2f2f2;
  background-color: #ebeff2;
  color: #6d6f7b;
}
.login-attendee .attendee {
  color: rgb(28, 29, 38);
  font-size: 24px;
  font-weight: 500;
}
.login-attendee .welcome {
  font-size: 24px;
  padding-right: 5px;
}
</style>

<style scoped>
.login-page-wrapper {
  background-size: cover;
}
.clsCancel {
  width: 100%;
  padding: 6px 0;
  color: #1e1f26;
  border: none;
  background: transparent;
}

.base-btn {
  border-radius: 16px;
  padding: 20px 24px;
  text-align: center;
  color: #fff;
  border-width: 2px;
  position: relative;
  z-index: 1;
  transition: all 300ms ease-in-out;
  display: inline-block;
  font-size: 20px;
}
.banner-btn {
  border-radius: 100px;
  /* background: url("/videos/banner-btn-bg.mp4") no-repeat center; */
}
.banner-btn video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
</style>
